import { APP_FLOW } from "../../common/constant"

export const getAppFlow = () => {
//   console.log(sessionStorage.getItem("flowType") === APP_FLOW.FIDYAH, 'fidyahh', sessionStorage.getItem("flowType"))
    return (
        sessionStorage.getItem("flowType") === APP_FLOW.FIDYAH ||
        window.location.pathname.includes("fidyah")
    ) ? APP_FLOW.FIDYAH
        : (
            sessionStorage.getItem("flowType") === APP_FLOW.KAFFARAH ||
            window.location.pathname.includes("kaffarah")
        ) ? APP_FLOW.KAFFARAH
            : (
                sessionStorage.getItem("flowType") === APP_FLOW.ILMU ||
                window.location.pathname.includes("wakaf-ilmu") || (window.location.origin.includes("wakaf") &&  !window.location.pathname.includes("wms") && !window.location.pathname.includes("pledging"))
            ) ? APP_FLOW.ILMU
            : (
                sessionStorage.getItem("flowType") === APP_FLOW.WMS ||
                window.location.pathname.includes("wms")
            ) ? APP_FLOW.WMS
            : (
                sessionStorage.getItem("flowType") === APP_FLOW.PLEDGE ||
                window.location.pathname.includes("pledging")
            ) ? APP_FLOW.PLEDGE
            : sessionStorage.getItem("flowType") === APP_FLOW.ZAKAT ? APP_FLOW.ZAKAT: '';
}
